import { createSelector } from 'reselect';

const getReviews = (state) => state.Reviews;

export const getPendingReviewsSelector = createSelector(
  getReviews,
  (reviews) => reviews.pendingReviews
);
